import logger from '@ally/whisper'
import { logLevel as level, logSilent as silent } from './constants'

export default logger({
  level,
  silent,
  nameSpace: 'host',
})
